
/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Md. Muhiminul Islam",
  description:
    "A passionate individual who always thrives to work on research and end to end products which develop sustainable and scalable social and technical systems to create impact.",
  og: {
    title: "Md. Muhiminul Islam",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "Md. Muhiminul Islam",
  logo_name: "Md. Muhiminul Islam",
  nickname: "Osim",
  subTitle:
    "Software Engineer \n ICPC Problem Setter & Judge \n Programming Trainer \nMachine Learning Enthusiast",
  resumeLink:
    "https://www.linkedin.com/in/muhimin-osim/",
  portfolio_repository: "https://github.com/MuhiminOsim",
  githubProfile: "https://github.com/MuhiminOsim",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Gmail",
    link: "mailto:muhiminul@gmail.com",
    fontAwesomeIcon: "fas fa-envelope", // Reference https://fontawesome.com/v5.15/icons/envelope?style=solid
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Github",
    link: "https://github.com/MuhiminOsim",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/muhimin-osim/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "StackOverflow",
    link: "https://stackoverflow.com/users/9038430/muhimin-osim",
    fontAwesomeIcon: "fa-stack-overflow", // Reference https://fontawesome.com/v5.15/icons/stack-overflow?style=brands
    backgroundColor: "#F58025", // Reference https://simpleicons.org/?q=stackover
  },
  {
    name: "YouTube",
    link: "https://www.youtube.com/channel/UCZ89iuzMm3DUv7gTCA7jOGw",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/muhimin.osim",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/muhimin_osim/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  {
    name: "Twitter",
    link: "https://twitter.com/@MuhiminulOsim",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Discord",
    link: "https://discordapp.com/users/517795903667568682",
    fontAwesomeIcon: "fa-discord", // Reference https://fontawesome.com/v5.15/icons/discord?style=brands
    backgroundColor: "#5865F2", // Reference https://simpleicons.org/?q=discord
  },
  {
    name: "LinkTree",
    link: "https://linktr.ee/Muhimin_Osim",
    fontAwesomeIcon: "fas fa-external-link-square-alt", // Reference https://fontawesome.com/v5.15/icons/fa-external-link-square-alt?style=solid
    backgroundColor: "#39E09B", // Reference https://simpleicons.org/?q=linktree 
  },
];

var styleColor = 0x3776AB;
const skills = {
  data: [
    {
      title: "Worked with",
      fileName: "SkillsImg",
      skills: [
        "⚡ Proficient in C, C++, Java, Kotlin & Python",
        "⚡ Deep Knowledge of Data Structures and Algorithms",
        "⚡ Advanced experiences in Image Processing & Computer Vision Technologies",
        "⚡ Vast Experience in Android App Development",
        "⚡ Good knowledge of Computer Graphics & OpenGL Rendering System",
      ],
      softwareSkills: [
        {
          skillName: "C/C++",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            backgroundColor: "transparent",
            color: "#" + styleColor.toString(16),
          },
        },
        {
            skillName: "Java",
            fontAwesomeClassname: "simple-icons:java",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "Kotlin",
            fontAwesomeClassname: "simple-icons:kotlin",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#" + styleColor.toString(16),
          },
        },
        {
            skillName: "Android",
            fontAwesomeClassname: "simple-icons:android",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "OpenGL",
            fontAwesomeClassname: "simple-icons:opengl",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "OpenCV",
            fontAwesomeClassname: "simple-icons:opencv",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "MySQL",
            fontAwesomeClassname: "simple-icons:mysql",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "Laravel",
            fontAwesomeClassname: "simple-icons:laravel",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "PHP",
            fontAwesomeClassname: "simple-icons:php",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "Python Flask",
            fontAwesomeClassname: "simple-icons:flask",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "GIT",
            fontAwesomeClassname: "simple-icons:git",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
        {
            skillName: "LaTex",
            fontAwesomeClassname: "simple-icons:latex",
            style: {
              backgroundColor: "transparent",
              color: "#" + styleColor.toString(16),
            },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Khulna University of Engineering & Technology, Khulna",
      subtitle: "B.Sc. in Computer Science and Engineering",
      logo_path: "kuet_logo.png",
      alt_name: "KUET",
      duration: "2017 - 2022",
      result: "CGPA: 3.80 (4.00)",
      descriptions: [
        //"⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
          "",
        //"⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "http://kuet.ac.bd",
    },
    {
        title: "Dhaka College, Dhaka",
        subtitle: "Higher Secondary",
        logo_path: "DC_logo.png",
        alt_name: "DC",
        duration: "2014 - 2016",
        result: "",
        descriptions: [
          //"⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
            "",
          //"⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
        ],
        website_link: "https://dhakacollege.edu.bd/",
      },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/A9M67MSJKKC3",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/7MMFFYCVKJW5",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
        title: "Algo Expert Course Completion",
        subtitle: "- Algo Expert",
        logo_path: "algoexpert_logo.png",
        certificate_link:
          "https://certificate.algoexpert.io/AlgoExpert%20Certificate%20AE-5d8f8134b4",
        alt_name: "algo_expert",
        color_code: "#00203E",
    },
    {
        title: "ICPC ID",
        subtitle: "- ICPC Foundation",
        logo_path: "icpc_logo.png",
        certificate_link:
          "https://icpc.global/ICPCID/A8OZXHZSPAO3",
        alt_name: "ICPC ID",
        color_code: "#FFFFFF",
    },
    /*
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },*/
  ],
};

// Experience Page
const experience = {
  title: "Experiences",
  //subtitle: "Job, Problem Setting and Volunteership",
  description:
    "",
  header_image_path: "undraw_experience.svg",
  sections: [
    {
        title: "Job Experiences",
        experiences: [
          {
            title: "Software Engineer",
            company: "Kite Games Studio",
            company_url: "https://www.kitegamesstudio.com/",
            logo_path: "KGS_logo.png",
            duration: "April 2022 - Present",
            location: "Mohakhali DOHS, Dhaka, Bangladesh",
            description:
              "• Contributing to face beautification tasks such as acne removal, eye brightening, teeth whitening, hair coloring, eye lash replacement, etc using computer vision and image processing techniques for the Beauty Editor application\n• Contributed to a real-time camera frame manipulation system using OpenGL rendering for the Time Warp Scan application that lets users make videos and photos by freezing the frame on the screen with a moving blue line\n• Carried out R&D on black and white image colorization ML model currently used in iOS and Android apps\n• Worked with RESTful APIs using Retrofit (OkHttp) and configured self-signed SSL certificates in projects\n• Contributed to the development of a generic purchase module for Android apps using MVVM architecture\n• Implementing dynamic and complex UI designs for Android apps\n• Contributing to the support and maintenance of several active apps on Play Store (1-10M+ downloads)",
            color: "#3D813E",
          },
        ],
    },
    {
      title: "Problem Setting",
      experiences: [
        {
          title: "Problem Setter & Judge",
          company: "National High School Programming Contest 2020 - Preliminary",
          company_url: "https://toph.co/c/nhspc2020-preliminary",
          logo_path: "NHSPC_logo.png",
          duration: "June 2020",
          location: "Judging Platform - Toph",
          description:
            "I was one of the problem setter and judges of National High School Programming Contest 2020 - Preliminary. The problem I set was 'Osim's Maze'.",
          color: "#21358B",
        },
        {
            title: "Co-ordinator, Problem Setter & Judge",
            company: "Intra KUET Programming Contest 2020",
            company_url: "https://toph.co/c/intra-kuet-2020",
            logo_path: "ikpc_logo.jpg",
            duration: "July 2020",
            location: "Judging Platform - Toph",
            description:
              "I was the co-ordinator and one of the problem setter and judges of Intra KUET Programming Contest 2020. The problem I set was 'Show Off!'.",
          color: "#117072",
        },
        {
            title: "Problem Setter & Judge",
            company: "Toph Criterion 2020 Round 4",
            company_url: "https://toph.co/c/criterion-2020-round-4",
            logo_path: "toph_logo.png",
            duration: "March 2020",
            location: "Judging Platform - Toph",
            description:
              "I was one of the problem setter and judges of Toph Criterion 2020 Round 4. The problem I set was 'Maximum Meetings'.",
          color: "#22313F",
        },
        {
            title: "Problem Setter & Judge",
            company: "The Tough Winter Spar 2019",
            company_url: "https://toph.co/c/tough-winter-spar-2019",
            logo_path: "toph_logo.png",
            duration: "December 2019",
            location: "Judging Platform - Toph",
            description:
              "I was one of the problem setter and judges of The Tough Winter Spar 2019. The problem I set was 'Milad's Lost Tree'.",
          color: "#22313F",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "President & Instructor",
          company: "Special Group Interested in Programming Contest (SGIPC)",
          company_url: "https://www.facebook.com/sgipc.kuet",
          logo_path: "SGIPC_logo.png",
          duration: "February 2020 - January 2022",
          location: "Khulna University of Engineering & Technology (KUET), Khulna",
          description:
            "Special Group Interested in Programming Contest (SGIPC) is a university club for the entusiastic competitive programmers of Khulna University of Engineering & Technology (KUET). As a president, I love leading the executing committee to arrange workshops, events, contests etc. to improve problem solving skills. As an instructor, I teach competitive programming to the junior members.",
          color: "#822D87",
        },
        {
            title: "Co-ordinator, Problem Setter & Judge",
            company: "Intra KUET Programming Contest 2020",
            company_url: "https://toph.co/c/intra-kuet-2020",
            logo_path: "ikpc_logo.jpg",
            duration: "July 2020",
            location: "Khulna University of Engineering & Technology, Khulna",
            description:
              "Intra KUET Programming Contest 2020 was held for the enthusiastic competitive programmers of KUET. As a president, I was the co-ordinator of all the activities of the event. I was also one of the problem setter and judges of this contest.",
            color: "#117072",
        },
        {
            title: "Organizing Volunteer",
            company: "Bangladesh Olympiad in Informatics 2019 Divisional",
            company_url: "https://olympiad.org.bd/",
            logo_path: "bdio_logo.svg",
            duration: "March 2017",
            location: "Khulna University of Engineering & Technology, Khulna",
            description:
              "Bangladesh Olympiad in Informatics 2019 Khulna Divisional Round was held in Khulna University of Engineering & Technology (KUET). As a student of the host university, I volunteered in the organization of the event.",
            color: "#FEC10D",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "All these projects except leetcode solutins and competitive programming were developed for the academic purposes with the aim to leverage the concepts of CS fundamentals.",
  avatar_image_path: "undraw_projects.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "muhiminul.png",
    description:
      "I am available on almost every social media. You can message or email me. I will try to reply within 24 hours.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://ashutoshhathidara.wordpress.com",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "North Kafrul, Dhaka - 1206",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8320758513",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  contactPageData,
};
